import React, { useEffect, useState } from "react";
// import {useNavigate} from 'react-router';
import { APP_BASE_ROUTE, APP_ROUTES } from "../../constants";
import "./style.scss";
import introBg from "../../../images/intro-bg.png";
import introLogoTitle from "../../../images/intro-logo-title.png";
import introLogoTv3 from "../../../images/intro-tv3.png";
import introLogoTv3Date from "../../../images/intro-tv3-date.png";
import introKidsme from "../../../images/intro-kidsme.png";
import { CommonUtil } from "../../utils/CommonUtil";
import { useNavigate } from "react-router-dom";
import { BigGreenButton } from "ladybug/jsx/components";

export const IntroPage = ({ error, isChatMember }) => {
  const navigate = useNavigate();
  const [isAfterDecember21, setIsAfterDecember21] = useState(false);

  useEffect(() => {
    const checkDate = () => {
      const today = new Date();
      const december21At2200 = new Date(2024, 11, 21, 22, 0, 0);
      setIsAfterDecember21(today >= december21At2200);
    };
  
    checkDate();
  }, []);

  useEffect(() => CommonUtil().ymReachGoal("ladybug_game_view_intro"), []);
  useEffect(() => {
    if (false === error) {
      console.log("[Ladybug.Intro] > ready");
      window.setTimeout(() => {
        // const hash = window.location.hash;
        // window.location.assign(
        //   APP_BASE_ROUTE + APP_ROUTES.HOME + (hash.length > 1 ? hash : "")
        // );
        const params = new URLSearchParams(window.location.search);
        params.set("shouldReload", "true");
        window.location.href = `/home?${params.toString()}`;
      }, 1234);
    } else {
      console.error("[Ladybug.Intro] > not ready");
    }
  }, [error, navigate]);

  // useEffect(() => {
  //   console.log('ЗАГРУЗКА intro');
  //   localStorage.setItem('isFirstVisit', 'true');
  // }, []);

  return (
    <div className="app-intro">
      <img src={introBg} alt="" className="app-intro--ball" />
      <div className="app-intro--overlay-top"></div>
      <div className="app-intro--overlay-bottom"></div>
      <img src={introLogoTitle} alt="" className="app-intro--logo-title" />
      <img
        src={isAfterDecember21 ? introLogoTv3 : introLogoTv3Date}
        alt=""
        className={`app-intro--logo-tv3 ${!isAfterDecember21 ? "date" : ""}`}
      />
      {/* {!error && !isChatMember && (
        <div className="app-intro--subscribe">
          <div className="app-intro--subscribe-title">
            Чтобы играть, нужно подписаться <br/> на телеграм-канал ТВ-3
          </div>
          {!error && !isChatMember && (
            <a href="https://t.me/tv3_test" className="app-intro--subscribe-button">
              <BigGreenButton onClick={() => {
                CommonUtil().ymReachGoal("ladybug_game_navigate_to_the_channel");
              }}>Подписаться на канал ТВ-3</BigGreenButton>
            </a>
          )}
        </div>
      )} */}
      {!error && (
        <div className="app-intro--progressbar">
          <div></div>
        </div>
      )}
      {!error && <img src={introKidsme} alt="" className="app-intro--kidsme" />}
      {error && (
        <div className="app-intro--error">Хмм... Что-то пошло не так 🤔</div>
      )}
    </div>
  );
};
